import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import FieldType from 'app/admin/dataset/dto/FieldType';

import AspectService from 'app/admin/aspect/service/AspectService';
import SimulationMonitorLogService from 'app/admin/simulationMonitorLog/service/SimulationMonitorLogService';
import SimulationMonitorEditService from '../service/SimulationMonitorEditService';

const config = data => {
	return {
		key: 'simulationMonitorEditForm',
		topic: 'simulationMonitor',
		service: SimulationMonitorEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'fields' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'aspect',
					component: EditFormSelectField,
					required: true,
					items: () => AspectService.getListSelection()
				},
				{
					key: 'simulationMonitorLog',
					component: EditFormSelectField,
					required: true,
					items: () => SimulationMonitorLogService.getListSelection()
				},
				{
					key: 'readInterval',
					component: EditFormTextField,
					type: 'number',
					integerOnly: true
				},
				{
					key: 'timeWindow',
					component: EditFormTextField,
					type: 'number',
					integerOnly: true
				},
				{
					key: 'maxIterations',
					component: EditFormTextField,
					type: 'number',
					integerOnly: true
				},
				{
					key: 'fields',
					tab: 'fields',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						type: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(FieldType).map(key => {
								return { label: FieldType[key], value: key };
							})
						},
						{
							key: 'sigma',
							component: EditFormTextField,
							required: true,
							type: 'number'
						},
					]
				}
			];

			return fields;
		}
	};
};

function SimulationMonitorEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(SimulationMonitorEditForm);